import { render, staticRenderFns } from "./homeBottom.vue?vue&type=template&id=71b28a57&scoped=true"
import script from "./homeBottom.vue?vue&type=script&lang=js"
export * from "./homeBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b28a57",
  null
  
)

export default component.exports